function HeartEchoVO(id, leftAtriumSize, rightVentricleSize, leftVentricleSize, pulmonaryTrunkSize, interventricularSeptumThickness, posteriorWallThickness, rightVentricleThickness,
                     aortaWidth, ascendingAortaWidth, mitralInflowVelocity, mitralInflowDuration, mitralEarlyInflowDecelerationDuration, mitralValveExaminationDetails, mitralValveComment,
                     aorticValveMaxFlowVelocity, aorticValveMaxPg, aorticValveExaminationDetails, aorticValveComment, tricuspidValveMaxFlowVelocity, tricuspidValveMaxPg, tricuspidValveExaminationDetails,
                     tricuspidValveComment, pulmonaryValveMaxFlowVelocity, pulmonaryValveAct, pulmonaryValveExaminationDetails, pulmonaryValveComment, ejectionFraction, contractilityDetails,
                     contractilityComment, pericardiumInflowVelocity, pericardiumTapse, pericardialDetails, pericardialComment, otherComments, conclusions, visitCard,
                     creationDate, alreadyPrinted) {
    this.id = id;
    this.leftAtriumSize = leftAtriumSize;
    this.rightVentricleSize = rightVentricleSize;
    this.leftVentricleSize = leftVentricleSize;
    this.pulmonaryTrunkSize = pulmonaryTrunkSize;
    this.interventricularSeptumThickness = interventricularSeptumThickness;
    this.posteriorWallThickness = posteriorWallThickness;
    this.rightVentricleThickness = rightVentricleThickness;
    this.aortaWidth = aortaWidth;
    this.ascendingAortaWidth = ascendingAortaWidth;
    this.mitralInflowVelocity = mitralInflowVelocity;
    this.mitralInflowDuration = mitralInflowDuration;
    this.mitralEarlyInflowDecelerationDuration = mitralEarlyInflowDecelerationDuration;
    this.mitralValveExaminationDetails = mitralValveExaminationDetails;
    this.mitralValveComment = mitralValveComment;
    this.aorticValveMaxFlowVelocity = aorticValveMaxFlowVelocity;
    this.aorticValveMaxPg = aorticValveMaxPg;
    this.aorticValveExaminationDetails = aorticValveExaminationDetails;
    this.aorticValveComment = aorticValveComment;
    this.tricuspidValveMaxFlowVelocity = tricuspidValveMaxFlowVelocity;
    this.tricuspidValveMaxPg = tricuspidValveMaxPg;
    this.tricuspidValveExaminationDetails = tricuspidValveExaminationDetails;
    this.tricuspidValveComment = tricuspidValveComment;
    this.pulmonaryValveMaxFlowVelocity = pulmonaryValveMaxFlowVelocity;
    this.pulmonaryValveAct = pulmonaryValveAct;
    this.pulmonaryValveExaminationDetails = pulmonaryValveExaminationDetails;
    this.pulmonaryValveComment = pulmonaryValveComment;
    this.ejectionFraction = ejectionFraction;
    this.contractilityDetails = contractilityDetails;
    this.contractilityComment = contractilityComment;
    this.pericardialDetails = pericardialDetails;
    this.pericardialComment = pericardialComment;
    this.otherComments = otherComments;
    this.conclusions = conclusions;
    this.visitCard = visitCard;

    this.creationDate = creationDate;
    this.alreadyPrinted = alreadyPrinted;

    var _typeContext = {
        creationDate: Date,
        visitCard: VisitCardVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
